"use strict";

export default class Platform
	{

	};


// var PF = Platform;
// var Platform = Platform;